var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5199 12.4853C20.5298 12.6372 20.5298 12.789 20.5298 12.9423C20.5298 17.6131 17.1452 23 10.9564 23V22.9972C9.12813 23 7.33789 22.4498 5.79883 21.4125C6.06467 21.4461 6.33184 21.4629 6.59967 21.4636C8.11475 21.465 9.58652 20.9309 10.7785 19.9475C9.33867 19.9188 8.07611 18.9326 7.63504 17.4927C8.1394 17.5949 8.65908 17.5739 9.15412 17.4319C7.58441 17.0987 6.45509 15.6498 6.45509 13.9671C6.45509 13.9517 6.45509 13.937 6.45509 13.9223C6.92281 14.196 7.44649 14.3478 7.98216 14.3646C6.50373 13.3266 6.04801 11.2603 6.9408 9.64484C8.64909 11.8532 11.1696 13.1957 13.8752 13.3378C13.6041 12.1101 13.9745 10.8236 14.8486 9.96052C16.2038 8.62221 18.3352 8.6908 19.6091 10.1138C20.3626 9.95772 21.0848 9.66724 21.7458 9.25567C21.4946 10.0739 20.9689 10.769 20.2667 11.2106C20.9336 11.128 21.5852 10.9405 22.1988 10.6542C21.7471 11.3653 21.1781 11.9848 20.5199 12.4853Z",
    fill: "#001636",
    fillOpacity: 0.92
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.192cf639db1e4dafb96c1878d91ac495.svg";
export { ForwardRef as ReactComponent };